var map = {
	"./affin_islamic.svg": 847,
	"./agrobank.svg": 848,
	"./al_rajhi.svg": 849,
	"./alliance_islamic.svg": 850,
	"./ambank_islamic.svg": 851,
	"./bank_islam.svg": 852,
	"./bank_muamalat.svg": 853,
	"./bank_rakyat.svg": 854,
	"./bank_simpanan_nasional.svg": 855,
	"./bnp_paribas.svg": 856,
	"./bpmp.svg": 857,
	"./cimb_islamic.svg": 858,
	"./citibank.svg": 859,
	"./hong_leong_islamic.svg": 860,
	"./hsbc_amanah.svg": 861,
	"./kuwait_finance_house.svg": 862,
	"./maybank_islamic.svg": 863,
	"./mbsb_bank.svg": 864,
	"./mufg.svg": 865,
	"./ocbc_bank.svg": 866,
	"./public_islamic_bank.svg": 867,
	"./rhb_islamic.svg": 868,
	"./sme_bank.svg": 869,
	"./standard_chartered.svg": 870,
	"./sumitomo_mitsui_banking_corp.svg": 871,
	"./uob_bank.svg": 872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 349;